module.exports = __webpack_public_path__ + "img/bend_arrow.2a98fc8.png";